import type { Prototype } from "../prototype-types";

export const taneishaLugoPrototypes: Prototype[] = [
  {
    id: "tl-brand-legal-passthrough-requirements",
    name: "Brand Legal Passthrough Requirements",
    path: "/tl/brand-legal-passthrough-requirements",
    description: "",
    owner: "Taneisha Lugo",
    createdAt: "2026-09-24",
    lastUpdated: "2026-09-24",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail:
      "/images/thumbnails/tl-brand-legal-passthrough-requirements.png",
    // The retailer-side prototype below is this project's one Feed entry
    // point; this brand-side screen is reached from there via the
    // Retailer/Brand toolbar switch (ExperienceSwitchToolbar), not browsed
    // to directly from the Feed.
    hidden: true,
  },
  {
    id: "tl-upmarket-plus-legal-passthrough-requirements",
    name: "Upmarket Plus Legal Passthrough Requirements",
    path: "/tl/upmarket-plus-legal-passthrough-requirements",
    description:
      "The workflow between retailers and brands sharing and agreeing to vendor compliance requirements.",
    owner: "Taneisha Lugo",
    createdAt: "2026-09-18",
    lastUpdated: "2026-09-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail:
      "/images/thumbnails/tl-upmarket-plus-legal-passthrough-requirements.png",
  },
];
